import { toggleFooter } from '@avalara/bat-apps-shared/client/helpers/index';

import { translate } from '@avalara/bat-apps-shared/i18n';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Pages } from '../../../../types/offers';
import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { pollForOfferPlan } from '../../lib/side-effects/polling';
import { selectState } from '../../selectors';
import { getEsbConfig } from '../../selectors/esb';
import { isEmbeddedSelector } from '../../selectors/offer';
import { setShowingLoadingRocket } from '../../store/data';
import { setCurrentOfferPage } from '../../store/offer';
import LoadingRocket from '../loading-rocket';

const SettingUp = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const isEsbTrialAddOn = useSelector(getEsbConfig) != null;
  const {
    offer: { provisioningDelayed, offerFlow },
    order: { selectedPlanName },
  } = useSelector(selectState);
  const isEmbedded = useSelector(isEmbeddedSelector);

  useEffect(() => {
    dispatch(setShowingLoadingRocket(true));
    return () => {
      dispatch(setShowingLoadingRocket(false));
    };
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: leaving as is
  useEffect(() => {
    if (!offerFlow) return;
    dispatch(setCurrentOfferPage(Pages.SettingUp));
    if (selectedPlanName) dispatch(pollForOfferPlan(offerFlow, selectedPlanName, history));
  }, [offerFlow]);

  useEffect(() => {
    // - Kyle: showing the footer on error so that Avalara contact information
    // can be seen by users in the embedded flow (normally footer is hidden in
    // the embedded flow)
    if (provisioningDelayed && isEmbedded) {
      const footer = document.querySelector('aui-footer');
      if (footer) {
        footer.className = '';
      }
    }
  }, [provisioningDelayed, isEmbedded]);

  let heading = '';
  if (provisioningDelayed) {
    heading = 'Setup is taking longer than usual';
  } else {
    heading = "We're getting you set up";
  }

  const subheading = (() => {
    if (isEsbTrialAddOn) return 'Stay on the page—this can take up to three minutes.';
    if (provisioningDelayed) {
      return (
        <span>
          {translate('client.general.stay-on-the-page-and-contact-your-account-manager-if-problem-doesnt-resolve', {
            contactButton: (chunks) => (
              <button type='button' className='pad-all-none pad-left-xs ghost-blue' onClick={toggleFooter}>
                {chunks}
              </button>
            ),
          })}
        </span>
      );
    }
    return 'This only takes a minute or so';
  })();

  return (
    <div className='text-center'>
      <div className='pad-top-sm pad-bottom-lg'>
        <h1 className='margin-bottom-sm'>{heading}</h1>
        <p className='margin-bottom-sm'>{subheading}</p>

        {isEsbTrialAddOn && <p>{"When we're done, you'll go to Avalara."}</p>}
      </div>

      <LoadingRocket />
    </div>
  );
};

export default SettingUp;
